import { Breadcrumb, Popover } from 'antd';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import {
  BULK_DOWNLOAD,
  BULK_UPLOAD_ROUTE,
  DASHBOARD_ROUTE,
  DETAILS_ROUTE
} from '../../constants';
import { getProjectRequest } from '../../redux/slicers/projects';
import { Images } from '../../theme';

import './styles.scss';

function BulkDownloadBreadCrumbs() {
  const params = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const { projectList } = state?.projects;
  const project = projectList?.find((p) => p._id === params.id);

  useEffect(() => {
    if (_.isEmpty(project)) {
      dispatch(getProjectRequest({}, () => {}));
    }
  }, []);

  const content = () => {
    return (
      <div className="breadCrumbWrapper">
        <Link to={DASHBOARD_ROUTE} className="customBreadcrumbMobView">
          Dashboard
        </Link>

        <Link
          className="customBreadcrumbMobView"
          to={DETAILS_ROUTE.replace(':id', params.id)}
        >
          {project?.projectname}
        </Link>

        <Link className="customBreadcrumb" to={BULK_UPLOAD_ROUTE}>
          bulk download
        </Link>
      </div>
    );
  };

  return (
    <>
      <div className="breadCrumbWebView">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link className="customBreadcrumb" to={DASHBOARD_ROUTE}>
              Dashboard
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link
              className="customBreadcrumb"
              to={DETAILS_ROUTE.replace(':id', params.id)}
            >
              {project?.projectname}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link
              className="customBreadcrumb"
              to={DETAILS_ROUTE.replace(':id', params.id)}
            >
              drawings
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link
              className="customBreadcrumb"
              to={BULK_DOWNLOAD.replace(':id', params.id)}
            >
              bulk download
            </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="breadCrumbMobView">
        <Popover content={content()} trigger="click">
          <img src={Images.folder} height={30} width={30} />
        </Popover>

        <Breadcrumb>
          <Breadcrumb.Item>
            <Link className="customBreadcrumb" to={BULK_UPLOAD_ROUTE}>
              upload
            </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
    </>
  );
}

export default BulkDownloadBreadCrumbs;
